import { mapDataResponseToBasketItem } from './basket-item';
export class BasketModel {
    constructor(funds = []) {
        this.funds = funds;
    }
}
export const mapDataResponseToBasket = (response) => {
    const basket = new BasketModel();
    const currentBasket = JSON.parse(response);
    basket.funds = currentBasket.funds.map((fund) => mapDataResponseToBasketItem(fund));
    return basket;
};
